import React, { useEffect, useState } from "react";
import BoxComponent from "../../../../../components/Box/BoxComponent";
import TypographyComponent from "../../../../../components/Typography/ThypographyComponent";
import { CategoriasProps, ItemCarrinho, ItemDestaque } from "../../../../Cardapio/public/CatalogoPage";
import ButtonComponent from "../../../../../components/Button/ButtonComponent";
import LabelComponent from "../../../../../components/Label/LabelComponent";
import TextFieldComponent from "../../../../../components/TextField/TextFieldComponent";
import SelectComponent from "../../../../../components/Select/SelectComponent";
import ItemCarrinhoCardComponent from "../../../../Cardapio/public/components/carrinho/ItemCarrinhoCardComponent";
import { formatNumberToDinheiro } from "../../../../../utils/dinheiro";
import { Usuario, UsuarioEnderecos } from "../../../../../provider/auth/AuthProps";
import { Autocomplete, TextField, Typography } from "@mui/material";
import { IMaskInput } from "react-imask";
import DadosUsuarioDrawer from "../../drawer/DadosUsuarioDrawer";

interface NovoPedidoInfoProps {
    onClose: () => void;
    telefoneCliente: string;
    dadosUsuariosCadastrados: Usuario[];
    dadosUsuarioSelecionado?: Usuario;
    onChangeUserData: (usuario: Usuario) => void;
    //onChangeUsuarioSelecionado: (usuario: Usuario) => void;
    onChangeTelefone: (telefone: string) => void;

    onChangeEndereco: (endereco: UsuarioEnderecos) => void;

    nomeCliente?: string;
    onChangeNomeCliente: (nome: string) => void;

    tipo: string;
    onChangeTipoPedido: (tipo: string) => void;

    pedidoPara: string;
    //onChangePedidoPara: (tipo: string) => void;

    formasPagamento: any[];
    //formaPagamentoSelecionada: string;
    formaPagamento: any;
    onChangeFormaPagamento: (formaPagamento: any) => void;

    observacao: string;
    onChangeObservacao: (observacao: string) => void;

    carrinho: ItemCarrinho[];
    onChangeCarrinho: (item: ItemDestaque) => void;
    onChangeQtdItem: (id: string, delta: number) => void;
    onChangeRemoveItem: (id: string) => void;

    vlrTotal: number;

    onSubmit: () => void;
};

export const CampoPedidoStyle = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: '6.02px',
    boxSizing: 'border-box',
    opacity: 1,

    // Paddings
    paddingTop: '12.04px',
    paddingRight: '18.06px',
    paddingBottom: '12.04px',
    paddingLeft: '18.06px',
    background: '#FFFFFF',
    borderBottom: '0.67px solid #E8DFD5',
};

export const CampoPedidoLabelStyle = {
    fontFamily: '"Font 1", sans-serif',
    fontWeight: 600,
    fontSize: 12,
    lineHeight: '12.04px',
    letterSpacing: '0em',
    color: '#7A6B63',
    display: 'inline-flex',
    alignItems: 'center',
    verticalAlign: 'middle',
};

export const CampoPedidoInputStyle = {
    width: '100%',
    backgroundColor: '#F8F5F0',
    borderTop: '0.75px solid #E8DFD5',
    boxShadow: '0px 0.75px 1.51px 0px rgba(0, 0, 0, 0.05)',
    opacity: 1,

    "& fieldset": {
        border: 'none',
    },

    "& .MuiOutlinedInput-root": {
        height: '27.09px',
        borderRadius: '4.52px',
        backgroundColor: '#F8F5F0',
        borderTop: '0.75px solid #E8DFD5',
        boxShadow: '0px 0.75px 1.51px 0px rgba(0, 0, 0, 0.05)',
        paddingRight: '32px',

        "&.Mui-error": {
            border: '1px solid #d32f2f',
        }
    },

    "& .MuiInputBase-input": {
        padding: 0,
        fontSize: '12px',
        boxSizing: 'border-box',
    },

    // TEXTFIELD
    "& .MuiInputBase-root": {
        padding: '0 8.95px',
        display: 'flex',
        alignItems: 'center',
    },

    // SELECT
    "& .MuiSelect-select": {
        height: '27.09px',
        display: 'flex',
        alignItems: 'center',
        padding: '0 8.95px !important',
        fontSize: '12px',
        boxSizing: 'border-box',
    },

    // HELPER
    "& .MuiFormHelperText-root": {
        marginLeft: 0,
        marginTop: '6px',
        fontSize: '11px',
        lineHeight: '14px',
    }

    /*
    height: '27.09px',
    borderRadius: '4.52px',
    backgroundColor: '#F8F5F0',
    borderTop: '0.75px solid #E8DFD5',
    boxShadow: '0px 0.75px 1.51px 0px rgba(0, 0, 0, 0.05)',
    opacity: 1,

    // Remove a borda padrão do fieldset para não conflitar com sua borderTop
    "& fieldset": { border: 'none' },

    // Ajusta o container do input (o componente pai da tag <input>)
    "& .MuiInputBase-root": {
        height: '27.09px',
        padding: '0 8.95px',
        display: 'flex',
        alignItems: 'center',
    },

    // Ajusta a tag <input> real para caber na altura
    "& .MuiInputBase-input": {
        padding: 0,
        height: '100%',
        fontSize: '12px',
        boxSizing: 'border-box',
    },
    */
};

const InfoPedidoComponent = (props: NovoPedidoInfoProps) => {
    const [openDrawerInfoUsuario, setOpenDrawerInfoUsuario] = useState(false);

    const handleChangeTipoPedido = (tipo: string) => {
        props.onChangeTipoPedido(tipo);
        props.onChangeNomeCliente("");
    }

    const handleUpdateQtd = (id: string, delta: number) => {
        props.onChangeQtdItem(id, delta);
    };

    const handleRemove = (id: string) => {
        props.onChangeRemoveItem(id);
    };

    const handleEnvioNovoPedido = () => {
        props.onSubmit();
    }

    const handleChangeTroco = (troco: string) => {
        props.onChangeFormaPagamento({
            ...props.formaPagamento,
            vlrTroco: troco
        });
    }

    useEffect(() => {
        console.log("TIVE ATUALIZACAO: ", props.dadosUsuariosCadastrados)
    }, [props.dadosUsuariosCadastrados])

    console.log(props)

    // const renderVlrTotal = () => {
    //     const totalComplementos = props.complementos.reduce(
    //         (soma: number, c: any) => soma + c.vlrUnitario,
    //         0
    //     );

    //     const totalComplementosEspecificos = props.complementosEspecificos.reduce(
    //         (soma: number, c: any) => soma + c.vlrUnitario,
    //         0
    //     );
    // }

    return <BoxComponent
        component="aside"
        sx={{
            display: "flex",
            flexDirection: "column",
            flex: 1,
            height: "100%",
            overflow: "hidden"
        }}
    >
        <BoxComponent component="div" sx={{
            height: '58.8px',
            display: 'flex',
            alignItems: 'center',
            // flex: 0.8,
            justifyContent: 'space-between',
            boxSizing: 'border-box',
            background: 'linear-gradient(90deg, #FF8C42 0%, #FF7A2A 100%)',
            borderBottom: '0.67px solid #E8DFD5',
            padding: '17.56px 18.06px 18.06px 18.06px',
            opacity: 1,
            borderRadius: '0px',
        }}>
            <TypographyComponent variant="h6"
                sx={{
                    fontFamily: '"Font 2", sans-serif',
                    fontWeight: 700,
                    fontSize: '18px',
                    lineHeight: '21.07px',
                    letterSpacing: '0em',
                    color: '#FFFFFF',
                    display: 'inline-flex',
                    alignItems: 'center',
                    verticalAlign: 'middle',
                    textTransform: 'none'
                }}
            >
                Novo pedido
            </TypographyComponent>
            <ButtonComponent id="botao-fechar-modal"
                variant="outlined"
                sx={{
                    display: "flex",
                    color: "#FFFFFF",
                    width: "21px",
                    height: "21px",
                    minWidth: 0,
                    minHeight: 0,
                    padding: 0,
                    border: "none"
                }}
                onClick={props.onClose}
            >
                X
            </ButtonComponent>
        </BoxComponent>

        <BoxComponent component="div"
            sx={{
                display: "flex",
                flexDirection: "column",
                flex: 8,
                minHeight: 0
            }}
        >
            <BoxComponent component="div" sx={CampoPedidoStyle}>
                <LabelComponent htmlFor="tipo_pedido" sx={CampoPedidoLabelStyle}>
                    Tipo
                </LabelComponent>
                <SelectComponent
                    id="tipo_pedido"
                    value={props.tipo}
                    onChange={(value) => handleChangeTipoPedido(value as string)}
                    //label="Tipo"
                    options={[
                        { label: "Mesa", value: "MESA" },
                        { label: "Delivery", value: "DELIVERY" },
                        { label: "Balcão", value: "BALCAO" }
                    ]}
                    sx={CampoPedidoInputStyle}
                />
            </BoxComponent>

            {(props.tipo === "MESA" || props.tipo === "BALCAO") && (
                <BoxComponent component="div" sx={CampoPedidoStyle}>
                    <LabelComponent htmlFor="nome_cliente" sx={CampoPedidoLabelStyle}>
                        Nome do cliente
                    </LabelComponent>

                    <TextFieldComponent
                        id="nome_cliente"
                        placeholder="Informe o nome do cliente..."
                        variant="outlined"
                        value={props.nomeCliente}
                        onChange={(e) => props.onChangeNomeCliente(e.target.value)}
                        fullWidth
                        sx={CampoPedidoInputStyle}
                    />
                </BoxComponent>
            )}

            {(props.tipo === "DELIVERY") && (
                <BoxComponent component="div" sx={CampoPedidoStyle}>
                    <LabelComponent htmlFor="nome_cliente" sx={CampoPedidoLabelStyle}>
                        Pesquisar cliente...
                    </LabelComponent>

                    <Autocomplete
                        options={props.dadosUsuariosCadastrados}
                        getOptionLabel={(option) => option.telefoneCompleto}

                        value={props.dadosUsuarioSelecionado || null}

                        inputValue={props.telefoneCliente || ""}

                        onInputChange={(event, newInputValue) => {
                            props.onChangeTelefone(newInputValue);
                        }}

                        onChange={(event: any, newValue: any) => {
                            props.onChangeUserData(newValue);
                        }}

                        filterOptions={(x) => x}

                        renderInput={(params) => (
                            <TextField
                                {...params}
                                //label="Pesquisar cliente"
                                placeholder="Digite o telefone..."
                                variant="outlined"
                                sx={CampoPedidoInputStyle}
                            />
                        )}
                    />

                    {/* AUTOCOMPLETE */}
                    {/* <TextFieldComponent
                        id="nome_cliente"
                        placeholder="Informe o telefone..."
                        variant="outlined"
                        value={props.telefoneCliente}
                        onChange={(e) => props.onChangeTelefone(e.target.value)}
                        fullWidth
                        sx={CampoPedidoInputStyle}
                        maskTelefone
                    /> */}

                    {props.dadosUsuarioSelecionado && (
                        <ButtonComponent id="usuario-selecionado"
                            onClick={() => setOpenDrawerInfoUsuario(true)}
                        >
                            {props.dadosUsuarioSelecionado.nome}
                        </ButtonComponent>
                    )}
                    {props.dadosUsuarioSelecionado == null && (
                        <ButtonComponent id="usuario-selecionado"
                            onClick={() => setOpenDrawerInfoUsuario(true)}
                        >
                            Cadastrar novo usuário
                        </ButtonComponent>
                    )}
                </BoxComponent>
            )}

            <BoxComponent component="div" sx={CampoPedidoStyle}>
                <LabelComponent htmlFor="retirada_pedido" sx={CampoPedidoLabelStyle}>
                    Pedido para
                </LabelComponent>
                <SelectComponent
                    id="retirada_pedido"
                    value="AGORA"
                    onChange={(value) => null}
                    //label="Tipo"
                    options={[{ label: "Agora", value: "AGORA" }]}
                    disabled
                    sx={CampoPedidoInputStyle}
                />
            </BoxComponent>
            <BoxComponent component="div" sx={CampoPedidoStyle}>
                <LabelComponent htmlFor="forma-pgto" sx={CampoPedidoLabelStyle}>
                    Forma de pagamento
                </LabelComponent>
                <SelectComponent
                    id="forma-pgto"
                    value={String(props.formaPagamento?.id ?? "")}
                    onChange={(value) => {
                        const formaSelecionada = props.formasPagamento.find(element => element.id == value);
                        props.onChangeFormaPagamento(formaSelecionada)
                    }}
                    //label="Tipo"
                    options={props.formasPagamento.map((formaPgto: any, index: number) => {
                        return {
                            label: formaPgto.nome,
                            value: String(formaPgto.id)
                        }
                    })}
                    sx={CampoPedidoInputStyle}
                />
            </BoxComponent>
            {props.formaPagamento.nome === "Dinheiro" && (
                <BoxComponent component="div" sx={CampoPedidoStyle}>
                    <LabelComponent htmlFor="troco" sx={CampoPedidoLabelStyle}>
                        Troco
                    </LabelComponent>
                    <TextFieldComponent
                        id="troco"
                        placeholder="Informe o troco"
                        variant="outlined"
                        value={props.formaPagamento.vlrTroco}
                        onChange={(e) => handleChangeTroco(e.target.value)}
                        fullWidth
                        sx={CampoPedidoInputStyle}
                        maskDinheiro
                        required
                    />
                </BoxComponent>
            )}
            <BoxComponent component="div" sx={CampoPedidoStyle}>
                <LabelComponent htmlFor="observacao" sx={CampoPedidoLabelStyle}>
                    Observação do pedido
                </LabelComponent>
                <TextFieldComponent
                    id="observacao"
                    placeholder="Ex: Sem cebola, extra queijo..."
                    value={props.observacao}
                    onChange={(e) => props.onChangeObservacao(e.target.value)}
                    fullWidth
                    sx={{
                        ...CampoPedidoInputStyle, "& .MuiOutlinedInput-root": {
                            height: 'auto',
                            borderRadius: '4.52px',
                            backgroundColor: '#F8F5F0',
                            borderTop: '0.75px solid #E8DFD5',
                            boxShadow: '0px 0.75px 1.51px 0px rgba(0, 0, 0, 0.05)',
                            paddingRight: '32px',

                            "&.Mui-error": {
                                border: '1px solid #d32f2f',
                            }
                        },
                    }}
                    multiline
                    maxRows={4}
                />
            </BoxComponent>

            <BoxComponent component="div" sx={{
                ...CampoPedidoStyle,
                flex: 1,
                minHeight: 0,
                overflow: "hidden"
            }}>
                <LabelComponent htmlFor="carrinho" sx={CampoPedidoLabelStyle}>
                    Carrinho
                </LabelComponent>

                <BoxComponent component="div" sx={{
                    flex: 1,
                    minHeight: 0,
                    overflowY: "auto"
                }}>
                    {props.carrinho.length > 0 && props.carrinho.map((element: ItemCarrinho, index: number) => {
                        return <ItemCarrinhoCardComponent
                            key={element.item.id}
                            item={element}
                            // ... props de funções aqui
                            onIncrement={(id) => handleUpdateQtd(id, 1)}
                            onDecrement={(id) => handleUpdateQtd(id, -1)}
                            onRemove={handleRemove}
                            onObsChange={() => null}
                        />
                    })}

                    {props.carrinho.length === 0 && (
                        <TypographyComponent variant="body1" sx={CampoPedidoLabelStyle}>
                            Sem itens
                        </TypographyComponent>
                    )}
                </BoxComponent>
            </BoxComponent>
        </BoxComponent>

        <BoxComponent component="div"
            sx={{
                // height: '98.91px',
                display: 'flex',
                flexDirection: 'column',
                flex: 0.8,
                gap: '9.03px',
                boxSizing: 'border-box',
                backgroundColor: '#F8F5F0',
                borderTop: '0.67px solid #E8DFD5',
                paddingTop: '11.53px',
                paddingRight: '18.06px',
                paddingBottom: '12.05px',
                paddingLeft: '18.06px',

                opacity: 1,
            }}
        >
            <BoxComponent component="div" sx={{ display: "flex", justifyContent: "space-between", width: '100%' }}>
                <TypographyComponent variant="body1" sx={CampoPedidoLabelStyle}>
                    Subtotal
                </TypographyComponent>
                <TypographyComponent variant="body2" sx={{
                    fontFamily: '"Font 1", sans-serif',
                    fontWeight: 700,
                    fontSize: '9.56px',
                    lineHeight: '15.05px',
                    letterSpacing: '0em',
                    color: '#3D2817',
                    display: 'inline-flex',
                    alignItems: 'center',
                    verticalAlign: 'middle',
                    textTransform: 'none'
                }}>
                    {formatNumberToDinheiro(props.vlrTotal)}                    
                </TypographyComponent>
            </BoxComponent>

            <ButtonComponent id="botao-pagamento-pedido"
                sx={{
                    height: '27.09px',
                    minWidth: 0,
                    minHeight: 0,
                    borderRadius: '4.52px',
                    backgroundColor: '#7B3FF2',
                    opacity: 0.5,

                    paddingTop: '5.52px',
                    paddingRight: '12.04px',
                    paddingBottom: '6.52px',
                    paddingLeft: '12.04px',

                    boxShadow: '0px 1.51px 6.02px 0px rgba(61, 40, 23, 0.08)',

                    color: '#FFFFFF',
                    textTransform: 'none',

                    '&:hover': {
                        backgroundColor: '#7B3FF2',
                        opacity: 0.7,
                    },

                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
                onClick={handleEnvioNovoPedido}
            >
                PAGAR
            </ButtonComponent>

            <TypographyComponent variant="body2"
                sx={{
                    fontFamily: '"Font 1", sans-serif',
                    fontWeight: 400,
                    fontSize: '10px',
                    lineHeight: '12.04px',
                    letterSpacing: '0em',
                    color: '#7A6B63',
                    textAlign: 'center',
                    display: 'block',
                    verticalAlign: 'middle',
                    textTransform: 'none'
                }}
            >
                R$ 0,00
            </TypographyComponent>
        </BoxComponent>

        <DadosUsuarioDrawer
            open={openDrawerInfoUsuario}
            onClose={(dadosUsuario: Usuario, endereco: UsuarioEnderecos) => {
                setOpenDrawerInfoUsuario(!openDrawerInfoUsuario);
                props.onChangeUserData(dadosUsuario);
                props.onChangeEndereco(endereco)
            }}
            userData={props.dadosUsuarioSelecionado}
            // onChangeUserData={(usuario: Usuario) => props.onChangeUserData(usuario)}
            onSubmit={(data) => {
                //console.log(data);
            }}
        />
    </BoxComponent>
}

export default InfoPedidoComponent;